import { createContext, useContext } from "react";
import * as React from "react";
import axios from "axios";
import { BranchView } from "./LocationConfiguration";

interface StationLocationContextType {
  stationLocation: BranchView;
}

const StationLocationContext = createContext<StationLocationContextType>(null);

export const useStationLocation = () => {
  const context = useContext(StationLocationContext);

  if (!context) {
    throw new Error(
      "useStationLocation must be used within a StationLocationProvider"
    );
  }

  return context;
};

const fetchStationLocation = async () => {
  try {
    const { data } = await axios.get<BranchView>("/stationLocation/thisBranch");

    // response can come back as an empty string when the backend returns null
    // not 100% sure about when it returns a BranchView
    if (typeof data === "string") {
      return JSON.parse(data) as BranchView;
    } else {
      return data;
    }
  } catch (e: unknown) {
    return null;
  }
};

export const StationLocationProvider = ({
  children,
}: React.PropsWithChildren) => {
  const [stationLocation, setStationLocation] =
    React.useState<BranchView>(null);

  React.useEffect(() => {
    fetchStationLocation().then((sl) => {
      setStationLocation(sl);
    });

    return () => {};
  }, []);

  // Define the context value
  const contextValue = {
    stationLocation,
  };

  return (
    <StationLocationContext.Provider value={contextValue}>
      {children}
    </StationLocationContext.Provider>
  );
};
